"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCategory = void 0;
var yup = require("yup");
var CategoryImage_1 = require("./CategoryImage");
var categorySchema = yup.object().shape({
    id: yup.string().required(),
    name: yup
        .object()
        .shape({
        en: yup.string().required(),
    })
        .required(),
    imageUrl: yup.string().optional(),
    isRoot: yup.boolean().optional(),
    priority: yup.number().optional(),
    categoryIds: yup.array().of(yup.string()).optional(),
    restrictions: yup.array().of(yup.string()).optional(),
    images: yup.array().of(CategoryImage_1.categoryImageSchema).optional(),
    saleorCollectionId: yup.string().required(),
    saleorPreviewCollectionId: yup.string().required(),
});
function isCategory(obj) {
    return categorySchema.isValidSync(obj);
}
exports.isCategory = isCategory;
